<re-alert *ngIf="successAlert" [type]="successAlert.type" (close)="successAlert = null">{{ successAlert.message }}</re-alert>
<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb px-0 pt-0">
    <li class="breadcrumb-item"><a [routerLink]="['/ect/customers']">Home</a></li>
    <li class="breadcrumb-item active">Customer Details</li>
  </ol>
</nav>

<h1>Customer Details</h1>

<div *ngIf="customerId">
  <div style="font-weight:bold">Customer Name</div>
  <div>{{customer.accountName}}</div>
</div>
<button (click)="goBack()" *ngIf="!editProfile" class="btn btn-default afterDiv">Back</button>

<fieldset [disabled]="isReadOnlyUser ? 'disabled' : null">
  <form id="customerDetailForm" [formGroup]="customerDetailForm">
    <div class="row">
      <div class="col-12 mb-4">
        <div class="card bg-light">
          <div class="card-header">
            <h4 class="mb-0">Details</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group mb-4">
                  <button class="btn btn-default" *ngIf="!editProfile" (click)="editProfileClicked()">Edit Details</button>
                  <button class="btn btn-success" *ngIf="editProfile" [disabled]="!customerDetailForm.valid || accountIdExists" (click)="updateCustomer()">Save</button>
                  <button class="btn btn-cancel" *ngIf="editProfile" (click)="cancel()">Cancel</button>
                  <button class="btn btn-danger" *ngIf="!editProfile && customerId!=null" (click)="deleteCustomer()">Delete Customer</button>
                </div>
              </div>
            </div>


            <div class="row">


              <div class="col-12 col-sm-3 form-group input-required">
                <label for="accountId">CRM ID</label>
                <input id="accountId" [(ngModel)]="customer.accountId" formControlName="accountId" value="{{customer.accountId}}"
                       type="text" [readonly]="!editProfile" [ngClass]="{'form-control': editProfile, 'form-control-plaintext': !editProfile}" (input)="accountIdChanged()">
                <small *ngIf="customerDetailForm.controls['accountId'].hasError('required') && customerDetailForm.controls['accountId'].touched"
                       class="text-danger">Please enter the CRM ID.</small>
                <small style="margin-left:2%" *ngIf="accountIdErrorMessage" class="text-danger">{{accountIdErrorMessage}}</small>
                <!--
                              <small *ngIf="customerDetailForm.controls['accountId'].hasError('maxLength')&& customerDetailForm.controls['accountName'].touched"
                                     class="text-danger">Maximum lenght should be 100</small>-->

              </div>



              <div class="col-12 col-sm-3 form-group input-required">
                <label>Customer Name</label>
                <input id="accountName" [(ngModel)]="customer.accountName" formControlName="accountName" value="{{customer.accountName}}" type="text" [readonly]="!editProfile" [ngClass]="{'form-control': editProfile, 'form-control-plaintext': !editProfile}">
                <small *ngIf="customerDetailForm.controls['accountName'].hasError('required') && customerDetailForm.controls['accountName'].touched"
                       class="text-danger">Please enter the Customer Name.</small>


              </div>

              <div class="col-md-6 col-lg-4 col-xl-3 form-group">
                <label for="guid">GUID</label>
                <i style="margin-left:2%" *ngIf="!guidSyncLoading" class="fa fa-refresh" (click)="customerGuidSync()" title="Sync Cofiguration GUIDs"></i>
                <i class="fa" [ngClass]="{'fa-fw': !guidSyncLoading, 'fa-spinner fa-spin': guidSyncLoading}"
                   [ngStyle] [style.color] = "getNgStyleColorBasedOnStatus('LOADING')"
                   aria-hidden="true"></i>
                <input class="p-0" formControlName="guid" id="guid" type="text" [readonly]="true" [ngClass]="{'form-control-plaintext': true}">
              </div>


            </div>

            <!-- Begin: Tracking dates -->
            <div class="row" *ngIf="customerId">
              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label>Created By</label>
                  <input formControlName="createdBy" type="text" [readonly]="true" [ngClass]="{'form-control-plaintext': true}">
                </div>
              </div>

              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label>Created Date</label>
                  <input formControlName="createdDate" type="text" [readonly]="true" [ngClass]="{'form-control-plaintext': true}">
                </div>
              </div>

              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label>Modified By</label>
                  <input formControlName="modifiedBy" type="text" [readonly]="true" [ngClass]="{'form-control-plaintext': true}">
                </div>
              </div>

              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label>Modified Date</label>
                  <input formControlName="modifiedDate" type="text" [readonly]="true" [ngClass]="{'form-control-plaintext': true}">
                </div>
              </div>

            </div>
            <!-- End: Tracking dates -->


          </div>
        </div>
      </div>
    </div>


    <button [disabled]="!customerId" style="margin-top:15px; margin-bottom:20px" type="button" routerLink="newConfiguration" class="btn btn-primary">  Add Configuration</button>
    <button [disabled]="!customerId" style="margin-top:15px; margin-bottom:20px" type="button" class="btn btn-primary" (click)="oktaConfigurationCall()">IDM Configuration (Okta)</button>



    <!--  <div class="table-responsive afterHeader">
      <table class="table table-striped table-bordered user-list">
        <thead class="thead">
        <tr>
          <th>Configurations</th>
          <th>Created Date</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let config of configurations">
          <td>
            <a [routerLink]="['/ect/configurations/detail/', config.id ]">{{ config.configName }}</a>
          </td>

          <td>
            {{config.createdDate | date:'medium'}}
          </td>
        </tr>

        </tbody>
      </table>
    </div>

    <h1>Config List 2</h1>-->



    <div class="table-responsive afterHeader">
      <table class="table table-striped table-bordered user-list" id="customerConfigurationList" #customerConfigurationList>
      </table>
      <div><i class="fa-regular fa-asterisk neo-success-3 small align-text-top"></i> Indicates Default Configuration.</div>
    </div>
    <div class="spinner" *ngIf="loading">
      <div class="lspinner"></div>
    </div>




    <!--  <table class="table table-condensed table-bordered table-striped table-hover responsive">
      <tr><th>Configurations</th><th>Create Date</th></tr>
      <tr ng-repeat="configuration in configurations | orderBy:'createdDate'">
        <td><span>{{configuration.configName}}</span></td>
        <td><span>{{configuration.createdDate|date:'short'}}</span></td>
      </tr>
    </table>-->


  </form>

  <div class="mt-5"><re-customer-parameters   [customerId]="customerId"></re-customer-parameters></div>

  <ng-template #modalContent let-closeResult="close" let-dismissResult="dismiss">

    <div class="modal-body ml-4 mr-2">
        <div class="row mt-1 mb-1">
            <h1> IDM Configuration </h1>
        </div>

        <div class="row mt-2 mb-2">
          <p> IDM Configuration is not set up for the customer <strong>{{customer.accountName}}</strong>. Please click on the Configure button if you want to proceed further with the setup. </p>
        </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="goToConfigurePage(true); closeResult();">Configure</button>
      <button type="button" class="btn btn-cancel" (click)="closeResult()">Close</button>
    </div>

</ng-template>

</fieldset>
